import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, ShieldCheckIcon, FileTextIcon, BellIcon, GlobeIcon, MoonIcon } from 'lucide-react';
export function Profile() {
  return <div className="flex-1 p-4 lg:p-8 max-w-3xl mx-auto w-full" data-id="element-2967">
      <h1 className="font-display font-bold text-3xl text-dark-navy mb-8" data-id="element-2968">
        Profile Settings
      </h1>

      <div className="space-y-6" data-id="element-2969">
        {/* Personal Info */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm" data-id="element-2970">
          <div className="flex items-center gap-4 mb-6" data-id="element-2971">
            <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center" data-id="element-2972">
              <UserIcon className="w-8 h-8 text-slate-400" data-id="element-2973" />
            </div>
            <div data-id="element-2974">
              <h2 className="font-bold text-xl text-slate-900" data-id="element-2975">
                Ahmed Al Mansoori
              </h2>
              <p className="text-slate-500" data-id="element-2976">Member since 2024</p>
            </div>
            <button className="ml-auto px-4 py-2 bg-slate-50 text-slate-700 rounded-xl font-medium hover:bg-slate-100 transition-colors" data-id="element-2977">
              Edit
            </button>
          </div>

          <div className="space-y-4" data-id="element-2978">
            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-2979">
              <div className="flex items-center gap-3" data-id="element-2980">
                <MailIcon className="w-5 h-5 text-slate-400" data-id="element-2981" />
                <div data-id="element-2982">
                  <p className="text-sm text-slate-500" data-id="element-2983">Email</p>
                  <p className="font-medium text-slate-900" data-id="element-2984">
                    ahmed@example.com
                  </p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-success/10 text-success text-xs font-bold rounded-full flex items-center gap-1" data-id="element-2985">
                <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-2986" /> Verified
              </span>
            </div>

            <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-2987">
              <div className="flex items-center gap-3" data-id="element-2988">
                <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-2989" />
                <div data-id="element-2990">
                  <p className="text-sm text-slate-500" data-id="element-2991">Phone</p>
                  <p className="font-medium text-slate-900" data-id="element-2992">+971 50 123 4567</p>
                </div>
              </div>
              <span className="px-2.5 py-1 bg-success/10 text-success text-xs font-bold rounded-full flex items-center gap-1" data-id="element-2993">
                <ShieldCheckIcon className="w-3.5 h-3.5" data-id="element-2994" /> Verified
              </span>
            </div>

            {/* UAE Pass Placeholder */}
            <div className="flex items-center justify-between p-4 bg-gradient-to-r from-slate-50 to-slate-100 rounded-xl border border-slate-200 border-dashed" data-id="element-2995">
              <div className="flex items-center gap-3" data-id="element-2996">
                <div className="w-8 h-8 bg-black rounded flex items-center justify-center text-white font-bold text-xs" data-id="element-2997">
                  UAE
                </div>
                <div data-id="element-2998">
                  <p className="font-bold text-slate-900" data-id="element-2999">UAE Pass</p>
                  <p className="text-sm text-slate-500" data-id="element-3000">
                    Verify your identity for higher trust score
                  </p>
                </div>
              </div>
              <button className="px-4 py-2 bg-black text-white rounded-xl font-medium text-sm hover:bg-slate-800 transition-colors" data-id="element-3001">
                Connect
              </button>
            </div>
          </div>
        </div>

        {/* Documents */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm" data-id="element-3002">
          <h3 className="font-bold text-lg text-slate-900 mb-4" data-id="element-3003">
            My Documents
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3004">
            <button className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-xl border border-slate-200 border-dashed hover:border-primary-indigo hover:bg-primary-indigo/5 transition-all group" data-id="element-3005">
              <ShieldCheckIcon className="w-8 h-8 text-slate-400 group-hover:text-primary-indigo mb-2" data-id="element-3006" />
              <span className="font-medium text-slate-700 group-hover:text-primary-indigo" data-id="element-3007">
                Emirates ID
              </span>
              <span className="text-xs text-slate-400 mt-1" data-id="element-3008">
                Used to verify your account
              </span>
            </button>
            <button className="flex flex-col items-center justify-center p-6 bg-slate-50 rounded-xl border border-slate-200 border-dashed hover:border-primary-indigo hover:bg-primary-indigo/5 transition-all group" data-id="element-3009">
              <FileTextIcon className="w-8 h-8 text-slate-400 group-hover:text-primary-indigo mb-2" data-id="element-3010" />
              <span className="font-medium text-slate-700 group-hover:text-primary-indigo" data-id="element-3011">
                Upload CV
              </span>
            </button>
          </div>
        </div>

        {/* Preferences */}
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm space-y-4" data-id="element-3012">
          <h3 className="font-bold text-lg text-slate-900 mb-2" data-id="element-3013">
            App Preferences
          </h3>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3014">
            <div className="flex items-center gap-3" data-id="element-3015">
              <BellIcon className="w-5 h-5 text-slate-500" data-id="element-3016" />
              <span className="font-medium text-slate-700" data-id="element-3017">Notifications</span>
            </div>
            <div className="relative inline-block w-10 h-6 rounded-full bg-primary-indigo cursor-pointer" data-id="element-3018">
              <span className="absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform translate-x-4" data-id="element-3019" />
            </div>
          </div>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3020">
            <div className="flex items-center gap-3" data-id="element-3021">
              <GlobeIcon className="w-5 h-5 text-slate-500" data-id="element-3022" />
              <span className="font-medium text-slate-700" data-id="element-3023">Language</span>
            </div>
            <select className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-sm font-medium text-slate-700 focus:outline-none focus:border-primary-indigo" data-id="element-3024">
              <option data-id="element-3025">English</option>
              <option data-id="element-3026">العربية</option>
            </select>
          </div>

          <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl" data-id="element-3027">
            <div className="flex items-center gap-3" data-id="element-3028">
              <MoonIcon className="w-5 h-5 text-slate-500" data-id="element-3029" />
              <span className="font-medium text-slate-700" data-id="element-3030">Theme</span>
            </div>
            <select className="bg-white border border-slate-200 rounded-lg px-3 py-1.5 text-sm font-medium text-slate-700 focus:outline-none focus:border-primary-indigo" data-id="element-3031">
              <option data-id="element-3032">Light</option>
              <option data-id="element-3033">Dark</option>
              <option data-id="element-3034">System</option>
            </select>
          </div>
        </div>
      </div>
    </div>;
}